import React, { useEffect } from 'react';
import { ModalBase } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import LoadErrorIcon from '../../../assets/icons/load_error.svg';
import LoadErrorIconUBPE from '../../../assets/icons/lead_error_UBPE.svg';

function LoadingError({ openModal, onClose, device, sendCustomTrackingInfo }) {
  const { t } = useTranslation();
  const isUBPE = process.env.REACT_APP_BUILD_SITE === 'UBPE';

  const iconToUse = isUBPE ? LoadErrorIconUBPE : LoadErrorIcon;

  useEffect(() => {
    sendCustomTrackingInfo({
      event: 'error_publicador',
      content_group: 'Publicador',
      error_type: 'Error de carga'
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ModalBase
      openModal={openModal}
      onClose={onClose}
      bottomModal={device === 'mobile'}
      width='412px'
      withoutCloseButton
      withoutOutsideClose
    >
      <Container device={device} data-publi='stepper-loadError-container'>
        <Illustration src={iconToUse} alt='Error ilustración' />
        <Title>{t('publisher.navigation.modal.loadError.title')}</Title>
        <Description>{t('publisher.navigation.modal.loadError.description')}</Description>
        <Button
          device={device}
          onClick={() => {
            onClose();
            window.location.reload();
          }}
        >
          {t('publisher.navigation.modal.loadError.CTA')}
        </Button>
      </Container>
    </ModalBase>
  );
}

const Container = styled.div`
  display: flex;
  width: ${({ device }) => (device === 'mobile' ? '100%' : '412px')};
  height: 364px;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Illustration = styled.img`
  width: 130px;
  height: 143px;
`;

const Title = styled.h2`
  color: ${select('Black')};
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
`;

const Description = styled.p`
  color: ${select('Black')};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  align-self: stretch;
  max-width: 364px;
  overflow: hidden;
  white-space: break-spaces;
`;

const Button = styled.button`
  display: flex;
  height: 48px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  max-width: ${({ device }) => (device === 'mobile' ? '100%' : '364px')};
  border-radius: 8px;
  background: ${getColor('primary')};
  color: ${select('white')};
  text-align: center;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  cursor: pointer;
  :hover {
    background-color: ${getColor('primaryHover')};
  }
`;

export { LoadingError };
